// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1tmOs","signatureBlock":"Footer_signatureBlock__G8-4i","signature":"Footer_signature__3G7Yv"};